import * as React from 'react';

import { ICurrency } from '@containers/App/model';

import { Line } from '../SelectedVariant/styled';

import {
  ConditionalVoucherDiscount,
  IConditionalVoucherDiscount,
} from './ConditionalVoucherDiscount';
import { LineWrapper } from './styled';
import { IVoucherDiscount, VoucherDiscount } from './VoucherDiscount';

interface IVoucherDiscountProps {
  voucherDiscount: IVoucherDiscount | IConditionalVoucherDiscount;
  currency: ICurrency;
  isUnderSelectBox?: boolean;
  hideLine?: boolean;
}

export const VoucherDiscountMaster = ({
  voucherDiscount,
  hideLine,
  ...rest
}: IVoucherDiscountProps) => {
  return (
    <>
      {isConditionalDiscount(voucherDiscount) ? (
        <ConditionalVoucherDiscount
          voucherDiscount={voucherDiscount}
          {...rest}
        />
      ) : (
        <VoucherDiscount voucherDiscount={voucherDiscount} {...rest} />
      )}

      {!hideLine && (
        <LineWrapper>
          <Line dashedLine={true} />
        </LineWrapper>
      )}
    </>
  );
};

const isConditionalDiscount = (
  discount: IConditionalVoucherDiscount | IVoucherDiscount
): discount is IConditionalVoucherDiscount => {
  return 'discountConditions' in discount;
};
